import React from "react";

const STATUS_CONFIG = {
  active: {
    title: "Subscription active",
    message:
      "Your subscription is active and ready to use.",
    accent:
      "border-pl-success/20 bg-[rgba(45,106,79,0.08)] text-pl-success",
  },
  pending_activation: {
    title: "Activating access",
    message:
      "Activation is in progress. We will update access shortly.",
    accent:
      "border-pl-info/20 bg-[rgba(43,108,176,0.08)] text-pl-info",
  },
  activation_failed: {
    title: "Activation failed",
    message:
      "Automatic activation failed. Retry from Pricing or contact support.",
    accent:
      "border-pl-error/20 bg-[rgba(155,34,38,0.08)] text-pl-error",
  },
  inactive: {
    title: "Subscription inactive",
    message:
      "Your account does not currently have active chat access. Start subscription to continue.",
    accent:
      "border-pl-warning/20 bg-[rgba(188,108,37,0.08)] text-pl-warning",
  },
  manual_review: {
    title: "Manual review in progress",
    message:
      "Payment is under review. Access will activate after verification.",
    accent:
      "border-pl-info/20 bg-[rgba(43,108,176,0.08)] text-pl-info",
  },
  trial_active: {
    title: "Free trial active",
    message:
      "Your free trial is active. Subscribe to continue after the trial period.",
    accent:
      "border-pl-success/20 bg-[rgba(45,106,79,0.08)] text-pl-success",
  },
  trial_ending_soon: {
    title: "Your free trial ends soon",
    message:
      "Subscribe now to keep access without interruption.",
    accent:
      "border-pl-warning/20 bg-[rgba(188,108,37,0.08)] text-pl-warning",
  },
  trial_pending_activation: {
    title: "Trial activation in progress",
    message:
      "Trial started, and access activation is in progress.",
    accent:
      "border-pl-info/20 bg-[rgba(43,108,176,0.08)] text-pl-info",
  },
  trial_activation_failed: {
    title: "Trial activation failed",
    message:
      "Trial started, but we could not activate access automatically. Please retry shortly or contact support.",
    accent:
      "border-pl-error/20 bg-[rgba(155,34,38,0.08)] text-pl-error",
  },
  trial_expired_access_paused: {
    title: "Your free trial has ended",
    message:
      "Subscribe to continue using the service.",
    accent:
      "border-pl-warning/20 bg-[rgba(188,108,37,0.08)] text-pl-warning",
  },

  // Legacy status compatibility
  success: undefined,
  already_subscribed: undefined,
  activating: undefined,
  pending: undefined,
  failed: undefined,
};

STATUS_CONFIG.success = STATUS_CONFIG.active;
STATUS_CONFIG.already_subscribed = STATUS_CONFIG.active;
STATUS_CONFIG.activating = STATUS_CONFIG.pending_activation;
STATUS_CONFIG.pending = STATUS_CONFIG.pending_activation;
STATUS_CONFIG.failed = STATUS_CONFIG.activation_failed;

const DEFAULT_SAFE_NON_ACTIVE = {
  title: "Access status unavailable",
  message:
    "Access status is not yet available. Refresh shortly or check Account for details.",
  accent: "border-pl-warning/20 bg-[rgba(188,108,37,0.08)] text-pl-warning",
};

const ChatStatusBanner = ({ status }) => {
  const config = STATUS_CONFIG[status] || (status ? DEFAULT_SAFE_NON_ACTIVE : null);

  if (!config) {
    return null;
  }

  return (
    <section
      aria-live="polite"
      className={`mb-8 rounded-10 border px-5 py-4 shadow-pl-sm ${config.accent}`}
    >
      <p className="text-12 font-semibold uppercase tracking-[0.18em]">
        Subscription Status
      </p>
      <h2 className="mt-2 text-18 font-semibold">{config.title}</h2>
      <p className="mt-2 text-14 leading-6 text-pl-text-secondary">
        {config.message}
      </p>
    </section>
  );
};

export default ChatStatusBanner;
